import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { Loader2, KeyRound, ArrowRight } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/_authenticated/partner/set-password")({
  head: () => ({ meta: [{ title: "Set A Password — What Finland" }, { name: "robots", content: "noindex,nofollow" }] }),
  component: SetPasswordPage,
});

function SetPasswordPage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    if (password.length < 8) return setErr("Password must be at least 8 characters.");
    if (password !== confirm) return setErr("Passwords do not match.");
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (error) return setErr(error.message);
    toast.success("Password saved — welcome");
    navigate({ to: "/partner" as never, replace: true });
  }

  async function skip() {
    navigate({ to: "/partner" as never, replace: true });
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-8">
        <div className="mx-auto h-12 w-12 rounded-full bg-slate-900 text-white flex items-center justify-center">
          <KeyRound className="h-5 w-5" />
        </div>
        <h1 className="mt-4 text-2xl font-semibold text-slate-900 text-center">Save Your Progress</h1>
        <p className="mt-2 text-sm text-slate-600 text-center">
          Choose a password so you can sign back into your Partner Dashboard while we review your listing.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">New Password</label>
            <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900/10" />
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">Confirm Password</label>
            <input type="password" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)}
              className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900/10" />
          </div>
          {err && <p className="text-sm text-rose-600">{err}</p>}
          <button type="submit" disabled={busy}
            className="w-full rounded-2xl bg-slate-900 text-white font-medium px-5 py-3 hover:bg-slate-800 disabled:opacity-60 inline-flex items-center justify-center gap-2">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ArrowRight className="h-4 w-4" />} Save Password
          </button>
        </form>
        <button onClick={skip} className="mt-4 w-full text-xs text-slate-500 hover:text-slate-900 text-center">
          Skip for now — I'll use magic links
        </button>
      </div>
    </div>
  );
}
